import { Action, Dispatch } from 'redux'
import { db, FirebaseDocumentDataType, FirebaseSnapshotType } from 'firebase/index'
import { CategoryType } from 'types/category'
import { fetchCategoriesAction } from 'reducks/category/actions'

const fetchCategories = () => {
  return async (dispatch: Dispatch<Action>) => {
    const categories = await db
      .collection('categories')
      .orderBy('order', 'asc')
      .get()
      .then((snapshots: FirebaseDocumentDataType) => {
        const _categories: CategoryType[] = []
        snapshots.forEach((snapshot: FirebaseSnapshotType) => {
          const data = snapshot.data() as CategoryType
          data.category_ref = snapshot.ref
          _categories.push(data)
        })
        return _categories
      })
      .catch((error: unknown) => {
        console.error(error)
        return []
      })

    dispatch(fetchCategoriesAction(categories))
  }
}

export default fetchCategories
